
class ProdMixOther extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup()
    }
    setup() { 
        console.log('ProdMixOther')
        new MasterTimeline({
            triggerInit: this,
            stagger: 0.15,
            scrollTrigger: { trigger: this },
            tweenArr: [ 
                new RevealText({ el: this.querySelector('.prod-mix-other-title .txt'), color: 'black', isFast: true }),
                ...Array.from(this.querySelectorAll(".prod-other-card")).map((el) => {
                    return new FadeIn({
                        el, from: {
                        y: parseRem(32),
                    } })
                })
            ]
        })
        
        if (getScreenType().isMobile) { 
            this.querySelectorAll('.prod-other-card').forEach((el) => el.classList.add('swiper-slide'));
            this.querySelector('.prod-mix-other-list').classList.add('swiper')
            this.querySelector('.prod-mix-other-list-inner').classList.add('swiper-wrapper');

            const productSwiper = new Swiper(this.querySelector('.prod-mix-other-list'), {
                modules: [Navigation, Scrollbar, Pagination],
                slidesPerView: 2,
                spaceBetween: parseRem(10),
                pagination: {
                    el: this.querySelector('.prod-mix-other-pagi'),
                    bulletClass: 'prod-mix-other-pagi-item',
                    bulletActiveClass: 'is-active',
                    clickable: true,
                },
            })
        }
    }
}

customElements.define('prod-mix-other', ProdMixOther);